import type { widgetOption } from "@/widgetMenu/widgetMenu";
import { wmBase } from "@/widgetMenu/wmBase";

export class WmTextStrike extends wmBase {
    constructor(options: widgetOption<boolean>[]) {
        super();
        this.options = options;
    }

    build() {
        const uniqValues = [...new Set(this.options.map((opt) => opt.value))];

        this.isStriked = uniqValues.length === 1 && uniqValues[0];

        const selectedClass = this.isStriked ? "wm_textStrike_selected" : "";
        const url = this.isStriked ? this.urlData.striked : this.urlData.notStriked;

        return `
            <div class="wm_textStrike ${selectedClass}">
                ${url}
            </div>
        `;
    }

    init() {
        const item = document.querySelector(".wm_textStrike");
        item?.removeEventListener("click", this.itemClick, false);
        item?.addEventListener("click", this.itemClick, false);
    }

    itemClick = (e: Event) => {
        const otherSubm = document.querySelector(".widgetSubMenu");
        if (otherSubm) {
            otherSubm.outerHTML = "";
        }

        this.isStriked = !this.isStriked;

        this.applyValue(this.options, this.isStriked);

        const menuItem = document.querySelector(".wm_textStrike");
        if (!menuItem) return;

        menuItem.classList.toggle("wm_textStrike_selected", this.isStriked);
        menuItem.innerHTML = this.isStriked ? this.urlData.striked : this.urlData.notStriked;
    };

    options: widgetOption<boolean>[] = [];
    isStriked = false;
    urlData = {
        notStriked: `
                <svg width="23" height="23" viewBox="0 0 86 110" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="5" y1="54.0547" x2="80.0752" y2="54.0547" stroke="black" stroke-width="10" stroke-linecap="round"/>
                <path d="M24.9183 42.25C5.52713 6.55257 67.6675 -3.58389 62.3789 31.2323" stroke="black" stroke-width="10" stroke-linecap="round"/>
                <path d="M59.6499 67.75C79.041 103.447 16.9006 113.584 22.1892 78.7677" stroke="black" stroke-width="10" stroke-linecap="round"/>
                </svg>
            `,
        striked: `
                <svg width="23" height="23" viewBox="0 0 86 110" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="5" y1="54.0547" x2="80.0752" y2="54.0547" stroke="white" stroke-width="10" stroke-linecap="round"/>
                <path d="M24.9185 42.25C5.52737 6.55257 67.6678 -3.58389 62.3792 31.2323" stroke="white" stroke-width="10" stroke-linecap="round"/>
                <path d="M59.6499 67.75C79.041 103.447 16.9006 113.584 22.1892 78.7677" stroke="white" stroke-width="10" stroke-linecap="round"/>
                </svg>
            `,
    };
}
